module.exports = {
      id: "online-news-usage",
      viewBox: "0 0 56.84 35.647",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#online-news",
      toString: function () {
        return this.url;
      }
    }